import { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult } from "@aws-amplify/api";
import { createLLMService } from "../graphql/mutations";
import {
  CreateLLMServiceInput,
  CreateLLMServiceMutation,
} from "../API";

export async function createLLMServiceAfterEdit(
  values: CreateLLMServiceInput
):Promise<GraphQLResult<CreateLLMServiceMutation>> {
  return API.graphql(
    graphqlOperation(createLLMService, {
      input: {
        name: values.name,
        status: values.status,
        vendor: values.vendor,
        region: values.region,
        endpoint: values.endpoint,
        body: values.body,
        header: values.header,
        loadProportion: values.loadProportion,
        projectId: values.projectId,
        inputTokenPricePerMillion: values.inputTokenPricePerMillion,
        outputTokenPricePerMillion: values.outputTokenPricePerMillion,
        groupId: values.groupId || "",
      },
    })
  ) as Promise<GraphQLResult<CreateLLMServiceMutation>>;
}
